import { Link } from "react-router-dom";
import Logo from "./Logo";

const sections = [
  {
    title: "Solutions",
    links: [
      { label: "Wholesale Voice Termination", to: "/solutions/wholesale-voice-termination" },
      { label: "For VoIP Operators", to: "/solutions/voip-operators" },
      { label: "For Resellers", to: "/solutions/resellers" },
      { label: "Call Centers & CPaaS", to: "/solutions/call-centers-cpaas" },
    ],
  },
  {
    title: "Company",
    links: [
      { label: "About us", to: "/company" },
      { label: "Why Voxmaster", to: "/why-voxmaster" },
      { label: "Network & Quality", to: "/network" },
      { label: "Compliance", to: "/company#compliance" },
    ],
  },
];

export default function Footer() {
  return (
    <footer className="bg-secondary-900 text-background-100 mt-24">
      <div className="max-w-7xl mx-auto px-4 md:px-6 py-16">
        <div className="grid grid-cols-1 md:grid-cols-12 gap-10">
          <div className="md:col-span-4">
            <div className="bg-background-50 inline-block rounded-md px-3 py-2">
              <Logo className="h-8" />
            </div>
            <p className="mt-5 text-sm text-background-300 leading-relaxed max-w-sm">
              Voxmaster LLC is a wholesale VoIP carrier delivering high-quality voice termination, DID origination, and SIP trunking to operators, resellers, call centers, and CPaaS platforms worldwide.
            </p>
            <div className="mt-6 flex items-center gap-3">
              {[
                { icon: "ri-linkedin-fill", href: "https://www.linkedin.com/company/voxmaster-llc", label: "LinkedIn" },
                { icon: "ri-twitter-x-line", href: "https://x.com/voxmaster", label: "X (Twitter)" },
                { icon: "ri-telegram-2-line", href: "https://t.me/voxmaster_sales", label: "Telegram" },
                { icon: "ri-whatsapp-line", href: "https://wa.me/17029830030", label: "WhatsApp" },
              ].map((s) => (
                <a
                  key={s.icon}
                  href={s.href}
                  target="_blank"
                  rel="noopener noreferrer nofollow"
                  className="w-9 h-9 rounded-md bg-secondary-800 hover:bg-primary-500 text-background-100 flex items-center justify-center transition-colors cursor-pointer"
                  aria-label={s.label}
                >
                  <i className={`${s.icon} text-base w-4 h-4 flex items-center justify-center`} />
                </a>
              ))}
            </div>
          </div>

          {sections.map((s) => (
            <div key={s.title} className="md:col-span-2">
              <h4 className="text-sm font-semibold text-background-50 mb-4">{s.title}</h4>
              <ul className="flex flex-col gap-2.5">
                {s.links.map((l) => (
                  <li key={l.to}>
                    <Link to={l.to} className="text-sm text-background-300 hover:text-primary-400 cursor-pointer">
                      {l.label}
                    </Link>
                  </li>
                ))}
              </ul>
            </div>
          ))}

          <div className="md:col-span-2">
            <h4 className="text-sm font-semibold text-background-50 mb-4">Contact</h4>
            <ul className="flex flex-col gap-2.5 text-sm text-background-300">
              <li className="flex items-start gap-2">
                <i className="ri-mail-line w-4 h-4 flex items-center justify-center mt-0.5" />
                <a href="mailto:sales@voxmaster.com" className="hover:text-primary-400 cursor-pointer">sales@voxmaster.com</a>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-customer-service-2-line w-4 h-4 flex items-center justify-center mt-0.5" />
                <span>24/7 NOC support</span>
              </li>
              <li className="flex items-start gap-2">
                <i className="ri-global-line w-4 h-4 flex items-center justify-center mt-0.5" />
                <span>Global carrier network</span>
              </li>
            </ul>
          </div>
        </div>
      </div>

      <div className="border-t border-secondary-800">
        <div className="max-w-7xl mx-auto px-4 md:px-6 py-5 flex flex-col sm:flex-row items-center justify-between gap-3 text-xs text-background-300">
          <p>© {new Date().getFullYear()} Voxmaster LLC. All rights reserved.</p>
          <div className="flex items-center gap-5">
            <Link to="/legal/privacy-policy" className="hover:text-primary-400 cursor-pointer whitespace-nowrap">Privacy Policy</Link>
            <Link to="/legal/terms-of-service" className="hover:text-primary-400 cursor-pointer whitespace-nowrap">Terms of Service</Link>
            <Link to="/legal/msa" className="hover:text-primary-400 cursor-pointer whitespace-nowrap">MSA</Link>
          </div>
        </div>
      </div>
    </footer>
  );
}